import React from "react";
import { formatDate } from "./utils";

const TeamOrdersTab = ({ teamOrders }) => (
  <div className="bg-white border border-line overflow-x-auto" data-testid="admin-team-orders-panel">
    <table className="w-full text-sm min-w-[800px]">
      <thead className="border-b border-line">
        <tr className="text-left">
          <th className="px-4 py-3 overline">Club</th>
          <th className="px-4 py-3 overline">Contact</th>
          <th className="px-4 py-3 overline">Email</th>
          <th className="px-4 py-3 overline">Players</th>
          <th className="px-4 py-3 overline">Colourways</th>
          <th className="px-4 py-3 overline">Created</th>
        </tr>
      </thead>
      <tbody>
        {teamOrders.length === 0 ? (
          <tr>
            <td colSpan="6" className="px-4 py-8 text-mute text-center">
              No enquiries yet.
            </td>
          </tr>
        ) : (
          teamOrders.map((t) => (
            <tr key={t.id} className="border-b border-line">
              <td className="px-4 py-3 font-medium">{t.club_name}</td>
              <td className="px-4 py-3">{t.contact_name}</td>
              <td className="px-4 py-3 mono text-xs">{t.email}</td>
              <td className="px-4 py-3 mono">{t.num_players}</td>
              <td className="px-4 py-3 text-xs text-mute">
                {(t.preferred_colourways || []).join(", ") || "—"}
              </td>
              <td className="px-4 py-3 mono text-xs text-mute">{formatDate(t.created_at)}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);

export default TeamOrdersTab;
